var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBespokeDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 82,
    viewBox: "0 0 99 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8277 20.325L18.0919 0.451942L18.1169 0.423096H43.1342L25.8277 20.325ZM14.5054 4.41656L0.586163 20.4231H20.7362L14.5054 4.41656ZM32.1554 20.4231H67.2281L49.8369 0.423096H49.5473L32.1554 20.4231ZM81.3781 0.550019L81.2677 0.423096H56.2492L73.6219 20.4019L81.3781 0.550019ZM98.7985 20.4231L84.9623 4.51233L78.7462 20.4231H98.7985ZM76.8562 25.4231L55.4392 80.2423L98.9231 25.4231H76.8562ZM0.461548 25.4231L43.9727 80.2808L22.6192 25.4231H0.461548ZM49.6673 81.5769L71.6615 25.4231H27.8112L49.6673 81.5769Z",
    fill: "#094C3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBespokeDiamond);
export default __webpack_public_path__ + "static/media/bespoke-diamond.0288fce78119e3657b255ecb1c417e99.svg";
export { ForwardRef as ReactComponent };